import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

import CustomTextField from "../../../components/ui/Textfield";
import { IFormProps, RATE_CARD_CURRENCIES } from "../types/rate-card";

interface AssignmentRateDialogProps {
  formData: IFormProps;
  formLoading: boolean;
  onClose: () => void;
  onInputChange: (name: string, value: string) => void;
  onSubmit: () => void;
  open: boolean;
  roleLabel?: string;
}

const AssignmentRateDialog: React.FC<AssignmentRateDialogProps> = ({
  formData,
  formLoading,
  onClose,
  onInputChange,
  onSubmit,
  open,
  roleLabel,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add Rate Card</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ pt: 1 }}>
          <Grid size={12}>
            <CustomTextField
              disabled
              fullWidth
              label="Role"
              value={roleLabel ?? ""}
            />
          </Grid>
          <Grid size={12}>
            <CustomTextField
              name="fixed_rate"
              label="Rate Amount"
              placeholder="Enter the rate amount"
              fullWidth
              value={formData.fixed_rate}
              onChange={(event) =>
                onInputChange("fixed_rate", event.target.value)
              }
              disabled={formLoading}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <FormControl fullWidth>
              <InputLabel id="assignment-rate-currency-label">
                Currency
              </InputLabel>
              <Select
                labelId="assignment-rate-currency-label"
                label="Currency"
                value={formData.currency}
                onChange={(event) =>
                  onInputChange("currency", event.target.value)
                }
              >
                {RATE_CARD_CURRENCIES.map((currency) => (
                  <MenuItem key={currency} value={currency}>
                    {currency}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <CustomTextField
              name="effective_date"
              label="Effective Date"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              fullWidth
              type="date"
              variant="outlined"
              value={formData.effective_date}
              onChange={(event) =>
                onInputChange("effective_date", event.target.value)
              }
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={formLoading}>
          Cancel
        </Button>
        <Button onClick={onSubmit} variant="contained" disabled={formLoading}>
          {formLoading ? (
            <CircularProgress size={18} color="inherit" sx={{ mr: 1 }} />
          ) : null}
          Save Rate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AssignmentRateDialog;
